export const escapeHtml = (value: string) =>
  value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");

export const plainTextToHtml = (value: string) =>
  escapeHtml(value).replace(/\r\n|\r|\n/g, "<br>");

// Inline blanks use the fill-in-the-blanks convention: `[answer]`. The captured
// group is the correct answer; blanks are matched to positions left-to-right,
// so ids are index-based and stay consistent between rendering and grading.
export const contentHasBlanks = (content: string | undefined | null): boolean =>
  !!content && /\[(.*?)\]/.test(content);

export const deriveBlanksFromContent = (
  content: string | undefined | null
): Array<{ id: string; value: string }> =>
  ((content || "").match(/\[(.*?)\]/g) || []).map((match, index) => ({
    id: `blank-${index}`,
    value: match.slice(1, -1),
  }));
